import React from 'react';

export interface FormProps
	extends React.DetailedHTMLProps<
		React.HTMLAttributes<HTMLFormElement>,
		HTMLFormElement
	> {}

/**
 * <form> that deals with some boiler plate settings
 */
const FormPrimitive = (
	props: FormProps,
	ref: React.ForwardedRef<HTMLFormElement>,
) => {
	return <form ref={ref} autoComplete="off" noValidate={true} {...props} />;
};

export const Form = React.forwardRef(FormPrimitive) as (
	props: FormProps,
) => JSX.Element;

export default Form;
